
import React, { useEffect , useState} from "react";

import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { UserManager, User } from "oidc-client-ts";
import oidcConfig from "../../utils/Authconfig";

import { setAuthenticated } from "../../redux/slices/loginSlice";
import { LOGIN_STATUS, STORAGE_KEY } from "../../utils/Constant";

import { saveInLocalStorage } from "../../utils/Util";

 

const Login = () => {
  const dispatch = useDispatch();
  const userManager = new UserManager(oidcConfig);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  // const [isProcessingCallback, setIsProcessingCallback] = useState(false);
 
  const checkAuthentication = async () => {
    try {
      const user = await userManager.getUser();
      if (user && user.access_token) {
        // console.log("User already authenticated:", user);
        onSuccessfulLogin(user);
      } else {
        // console.log("User not authenticated, redirecting to login...");
        callLogin();
      }
    } catch (error) {
      console.error("Error checking authentication:", error);
      callLogin();
    }
  };
 
  const callLogin = () => {
    userManager
      .signinRedirect()
      .then(() => {
        console.log("Login initiated");
      })
      .catch((error) => {
        console.error("Login error:", error);
      });
  };
 
  const handleCallback = async () => {
    // if (isProcessingCallback) return;
    // setIsProcessingCallback(true);
    try {
      const user = await userManager.signinRedirectCallback();
      if (user) {
        console.log("Callback successful, user authenticated:", user);
        // console.log("access_token", user.access_token);
        // console.log("refresh_token", user.refresh_token);
        onSuccessfulLogin(user);
      }
    } catch (error) {
      console.error("Callback processing error:", error);
    }
  };
 
  useEffect(() => {
    const isCallbackUrl = window.location.href.includes("code=");

    if (isCallbackUrl) {
        // Only process the callback if the user was redirected from login
        handleCallback();
    } else {
        // Check authentication status before redirecting to login
        checkAuthentication();
    }
}, []);
 
  const onSuccessfulLogin = async (payload) => {
    const AT = payload.access_token;
    const tokenPayload = JSON.parse(atob(AT.split(".")[1]));
    let CURRENT_ENV = process.env.REACT_APP_ENV || "development";
 

    const data = {
      employeeName: payload.profile.name,
      email: payload.profile.email,
      accessToken: payload.access_token,
      accessExpiryTime: payload.expires_at,
      refreshToken: payload.refresh_token,
      resetExpiryTime: payload.expires_at,
      mobile_device_token: null,
      groupname: tokenPayload.groups,
    };
    saveInLocalStorage(
      STORAGE_KEY.AUTH_DATA,
      JSON.stringify(data)
    );


    if (LOGIN_STATUS && LOGIN_STATUS.AUTHENTICATED) {
      dispatch(
          setAuthenticated({
              status: LOGIN_STATUS.AUTHENTICATED,
              user: data,
          })
      );
  } else {
      console.error("LOGIN_STATUS.AUTHENTICATED is undefined");
  }
 

    navigate("/home", { replace: true }); // Redirect to home page after login
  };
 
  return null;
};
 
export default Login;